import { Route, Redirect, Switch } from "react-router-dom";
import { useAuthContext } from "../../../auth-state";
import { OrganizationDetailPageContainer } from "./org-detail";
import { OrganizationProceduresListContainer } from "./org-detail/procedures-list";
import { OrganizationGroupsListContainer } from "./org-detail/groups-list";
import { OrganizationUserListContainer } from "./org-detail/user-list/user-list";
import { OrganizationAclSettingContainer } from "./org-detail/acl-settings";
import { ServiceProviderHomePageContainer } from "./home/home";
import { ServiceProviderRoute } from "../../helpers/service-provider-route";
import { OrganizationProcedureDetailContainer } from "./procedure-detail/procedure-detail";
import { PdfOutputConfiguration } from "../../organisms/smart-apply/procedure-detail/pdf-output-configuration/pdf-output-configuration";
import {
  NamedRoute,
  route,
} from "../../../application/domain/routing/named-route";
import { ServiceProviderLoginPage } from "./login";
import { ServiceProviderProcManagementRoutes } from "./proc-management/routes";
import { BannerNoticePageContainer } from "./banner-notice/banner-notice";
import { OrgProductsContainer } from "./org-detail/org-products";
import { MadoguchiEditorContainer } from "./madoguchi-editor/index";
import { ServiceProviderGrafferUtilityToolsRoutes } from "./graffer-utility-tools/routes";
import { OrganizationGroupUsersContainer } from "./org-detail/groups-users-list";
import { ProductDocsPage } from "./docs/docs";
import { OrganizationCustomerReviewsContainer } from "./org-detail/customer-reviews-list";
import { OrgGBizIDSettingContainer } from "./org-detail/org-gbizid-setting";
import { BoothReserveContainer } from "./booth-reserve";
import { CallContainer } from "./call";
import { OrganizationUserDetailContainer } from "./org-detail/user-detail";
import { ServiceProviderServiceAccountRoutes } from "./service-account/routes";
import { AiStudioContainer } from "./aistudio";
import { UsersNewPage } from "./org-detail/users-new";
import { ServiceProviderQualifiedInvoiceRoutes } from "./qualified-invoice/route";
import { ServiceProviderDataTransferRoutes } from "./data-transfer/routes";
import { OrganizationArchivedProceduresList } from "./org-detail/archived-procedures-list";
import { ServiceProviderOrgPaymentSettingPage } from "./org-detail/payment-setting/index";
import { ServiceProviderSmartApplyRoutes } from "./smart-apply/routes";
import { NinteiShoukaiContainer } from "./nintei-shoukai";
import { OrgProductDataRemovalTasksPage } from "./org-detail/product-data-removal-tasks";

export const ServiceProviderR = {
  Home: route({
    path: "/service-provider/home",
    component: ServiceProviderHomePageContainer,
  }),
  BannerNotice: route({
    path: "/service-provider/banner-notice",
    component: BannerNoticePageContainer,
  }),
  ProductDocs: route({
    path: "/service-provider/docs",
    component: ProductDocsPage,
  }),
  Basic: route({
    path: "/service-provider/basic/:id",
    link: (args: { id: string }) => `/service-provider/basic/${args.id}`,
    component: OrganizationDetailPageContainer,
  }),
  OrgUsers: route({
    path: "/service-provider/orgs/:orgId/users",
    link: (args: { orgId: string }) =>
      `/service-provider/orgs/${args.orgId}/users`,
    component: OrganizationUserListContainer,
  }),
  OrgUsersNew: route({
    path: "/service-provider/orgs/:orgId/users/new",
    link: (args: { orgId: string }) =>
      `/service-provider/orgs/${args.orgId}/users/new`,
    component: UsersNewPage,
  }),
  OrgUserDetail: route({
    path: "/service-provider/orgs/:orgId/users/:userId",
    link: (args: { orgId: string; userId: string }) =>
      `/service-provider/orgs/${args.orgId}/users/${args.userId}`,
    component: OrganizationUserDetailContainer,
  }),
  PaymentSetting: route({
    path: "/service-provider/orgs/:id/payment-setting",
    link: (args: { id: string }) =>
      `/service-provider/orgs/${args.id}/payment-setting`,
    component: ServiceProviderOrgPaymentSettingPage,
  }),
  Products: route({
    path: "/service-provider/orgs/:id/products",
    link: (args: { id: string }) =>
      `/service-provider/orgs/${args.id}/products`,
    component: OrgProductsContainer,
  }),
  ProductDataRemovalTasks: route({
    path: "/service-provider/orgs/:id/product-data-removal-tasks",
    link: (args: { id: string }) =>
      `/service-provider/orgs/${args.id}/product-data-removal-tasks`,
    component: OrgProductDataRemovalTasksPage,
  }),
  GBizIDSetting: route({
    path: "/service-provider/orgs/:id/gbizid-setting",
    link: (args: { id: string }) =>
      `/service-provider/orgs/${args.id}/gbizid-setting`,
    component: OrgGBizIDSettingContainer,
  }),
  Procedures: route({
    path: "/service-provider/orgs/:id/procedures",
    link: (args: { id: string }) =>
      `/service-provider/orgs/${args.id}/procedures`,
    component: OrganizationProceduresListContainer,
  }),
  ArchivedProcedures: route({
    path: "/service-provider/orgs/:id/archived-procedures",
    link: (args: { id: string }) =>
      `/service-provider/orgs/${args.id}/archived-procedures`,
    component: OrganizationArchivedProceduresList,
  }),
  ProcedureDetail: route({
    path: "/service-provider/orgs/:id/procedures/:procedureId",
    link: (args: { orgId: string; procedureId: string }) =>
      `/service-provider/orgs/${args.orgId}/procedures/${args.procedureId}`,
    component: OrganizationProcedureDetailContainer,
  }),
  CustomerReviews: route({
    path: "/service-provider/orgs/:id/customer-reviews",
    link: (args: { tenantId: string }) =>
      `/service-provider/orgs/${args.tenantId}/customer-reviews`,
    component: OrganizationCustomerReviewsContainer,
  }),
  ProcedurePDFOutputConfiguration: route({
    path: "/service-provider/orgs/:id/procedures/:procedureId/pdf-output-configuration",
    link: (args: { orgId: string; procedureId: string }) =>
      `/service-provider/orgs/${args.orgId}/procedures/${args.procedureId}/pdf-output-configuration`,
    component: PdfOutputConfiguration,
  }),
  Groups: route({
    path: "/service-provider/orgs/:id/groups",
    link: (args: { id: string }) => `/service-provider/orgs/${args.id}/groups`,
    component: OrganizationGroupsListContainer,
  }),
  GroupUsers: route({
    path: "/service-provider/orgs/:id/groups/:groupId/users",
    link: (args: { orgId: string; groupId: string }) =>
      `/service-provider/orgs/${args.orgId}/groups/${args.groupId}/users`,
    component: OrganizationGroupUsersContainer,
  }),
  ACL: route({
    path: "/service-provider/orgs/:id/acl",
    link: (args: { id: string }) => `/service-provider/orgs/${args.id}/acl`,
    component: OrganizationAclSettingContainer,
  }),
  MadoguchiEditor: route({
    path: "/service-provider/orgs/:id/madoguchi-editor",
    link: (args: { orgId: string }) =>
      `/service-provider/orgs/${args.orgId}/madoguchi-editor`,
    component: MadoguchiEditorContainer,
  }),
  BoothReserve: route({
    path: "/service-provider/orgs/:id/booth-reserve",
    link: (args: { orgId: string }) =>
      `/service-provider/orgs/${args.orgId}/booth-reserve`,
    component: BoothReserveContainer,
  }),
  AIStudio: route({
    path: "/service-provider/orgs/:id/aistudio",
    link: (args: { orgId: string }) =>
      `/service-provider/orgs/${args.orgId}/aistudio`,
    component: AiStudioContainer,
  }),
  Call: route({
    path: "/service-provider/orgs/:id/call",
    link: (args: { orgId: string }) =>
      `/service-provider/orgs/${args.orgId}/call`,
    component: CallContainer,
  }),
  NinteiShoukai: route({
    path: "/service-provider/orgs/:id/nintei-shoukai",
    link: (args: { orgId: string }) =>
      `/service-provider/orgs/${args.orgId}/nintei-shoukai`,
    component: NinteiShoukaiContainer,
  }),
  ...ServiceProviderSmartApplyRoutes,
  ...ServiceProviderProcManagementRoutes,
  ...ServiceProviderGrafferUtilityToolsRoutes,
  ...ServiceProviderServiceAccountRoutes,
  ...ServiceProviderQualifiedInvoiceRoutes,
  ...ServiceProviderDataTransferRoutes,
};

const LoginContainer = () => {
  const authAcc = useAuthContext();
  if (authAcc.isAuthed) {
    return <Redirect to={ServiceProviderR.Home.link({})} />;
  } else {
    return <ServiceProviderLoginPage />;
  }
};

export const ServiceProviderRoutes = () => {
  return (
    <Switch>
      {/*
          `/graffer-staff`で運用されていた期間が長く
          ドキュメントやメッセージにURLとして残っているため
          `/graffer-staff`でも遷移できるようにする
      */}
      <Route
        path="/graffer-staff"
        render={(props) => (
          <Redirect
            to={{
              pathname: props.location.pathname.replace(
                "/graffer-staff",
                "/service-provider",
              ),
              search: props.location.search,
            }}
          />
        )}
      />
      {/*
          ドキュメントやメッセージにURLとして残っているため
          最上位が`/surveys`でなくても遷移できるようにする
      */}
      <Route
        path="/service-provider/orgs/:orgId/surveys"
        render={(props) => (
          <Redirect
            to={{
              pathname: `/surveys${props.location.pathname}`,
              search: props.location.search,
            }}
          />
        )}
      />
      <Route exact path="/service-provider/login" component={LoginContainer} />
      {Object.keys(ServiceProviderR).map((k) => {
        const r = (ServiceProviderR as { [key: string]: NamedRoute<any> })[k]
          .forRouter;
        return (
          <ServiceProviderRoute
            exact
            path={r.path}
            component={r.component}
            key={`GrafferStaffRoutes-${k}`}
          />
        );
      })}
    </Switch>
  );
};
